export const PAYPAL_BUTTON_ID = "paypal-button";
